export const userWorkspaceEn = {
  "search": "Search name or email",
  "allRoles": "All roles",
  "allStatuses": "All statuses",
  "sort": "Sort users",
  "newest": "Newest created",
  "name": "Name A–Z",
  "email": "Email A–Z",
  "lastLogin": "Latest sign-in",
  "reset": "Reset filters",
  "passwordState": "Password",
  "temporary": "Change required",
  "personal": "No change required",
  "never": "Never signed in",
  "updated": "Updated / By",
  "created": "Created / By",
  "system": "System / legacy",
  "profile": "Account information",
  "profileHint": "Role or status changes revoke existing sessions. Disabled accounts cannot sign in.",
  "resetTitle": "Set temporary password",
  "resetHint": "Resetting {{email}} signs out all existing sessions. The user must choose a new password before accessing the system.",
  "acknowledge": "I understand this will sign out the user and require a password change.",
  "resetDone": "Temporary password saved. Previous sessions are revoked; a password change is required at next sign-in.",
  "createHint": "The initial password is temporary. The user must change it before accessing the system.",
  "history": "Security history",
  "historyHint": "Latest 100 events, recorded from this release onward. Password values are never recorded.",
  "noHistory": "No security events recorded yet.",
  "historyError": "Could not load security history.",
  "actor": "Performed by",
  "requiredPassword": "{{name}}, change your temporary password before continuing. Other pages remain unavailable until you finish.",
  "requiredGeneric": "Change your temporary password before continuing.",
  "signOut": "Sign out",
  "currentIncorrect": "The current password is incorrect.",
  "passwordUnchanged": "Choose a password different from your current password.",
  "accountChanged": "The account changed while saving. Sign in again and retry.",
  "passwordChanged": "Password changed. Other sessions have been signed out; this session remains active.",
  "edit": "Edit {{name}}",
  "event_created": "Account created",
  "event_profile_updated": "Name updated",
  "event_role_changed": "Role changed",
  "event_disabled": "Account disabled",
  "event_enabled": "Account enabled",
  "event_password_reset": "Temporary password reset",
  "event_password_changed": "Password changed by user"
};
export const userWorkspaceVi = {
  "search": "Tìm tên hoặc email",
  "allRoles": "Tất cả vai trò",
  "allStatuses": "Tất cả trạng thái",
  "sort": "Sắp xếp tài khoản",
  "newest": "Mới tạo trước",
  "name": "Tên A–Z",
  "email": "Email A–Z",
  "lastLogin": "Đăng nhập gần nhất",
  "reset": "Đặt lại bộ lọc",
  "passwordState": "Mật khẩu",
  "temporary": "Cần đổi mật khẩu",
  "personal": "Không yêu cầu đổi",
  "never": "Chưa đăng nhập",
  "updated": "Cập nhật / Người thực hiện",
  "created": "Tạo / Người thực hiện",
  "system": "Hệ thống / dữ liệu cũ",
  "profile": "Thông tin tài khoản",
  "profileHint": "Đổi vai trò hoặc trạng thái sẽ thu hồi các phiên hiện tại. Tài khoản bị khóa không thể đăng nhập.",
  "resetTitle": "Đặt mật khẩu tạm",
  "resetHint": "Đặt lại mật khẩu cho {{email}} sẽ đăng xuất tất cả phiên hiện tại. Người dùng phải đổi mật khẩu trước khi vào hệ thống.",
  "acknowledge": "Tôi hiểu thao tác này sẽ đăng xuất người dùng và yêu cầu đổi mật khẩu.",
  "resetDone": "Đã lưu mật khẩu tạm và thu hồi các phiên cũ. Người dùng phải đổi mật khẩu ở lần đăng nhập tiếp theo.",
  "createHint": "Mật khẩu ban đầu là mật khẩu tạm. Người dùng phải đổi mật khẩu trước khi vào hệ thống.",
  "history": "Lịch sử bảo mật",
  "historyHint": "100 sự kiện gần nhất, được ghi từ phiên bản này. Không ghi giá trị mật khẩu.",
  "noHistory": "Chưa có sự kiện bảo mật.",
  "historyError": "Không tải được lịch sử bảo mật.",
  "actor": "Người thực hiện",
  "requiredPassword": "{{name}}, hãy đổi mật khẩu tạm trước khi tiếp tục. Các trang khác chỉ mở sau khi hoàn tất.",
  "requiredGeneric": "Hãy đổi mật khẩu tạm trước khi tiếp tục.",
  "signOut": "Đăng xuất",
  "currentIncorrect": "Mật khẩu hiện tại không đúng.",
  "passwordUnchanged": "Hãy chọn mật khẩu khác mật khẩu hiện tại.",
  "accountChanged": "Tài khoản đã thay đổi trong lúc lưu. Hãy đăng nhập lại rồi thử lại.",
  "passwordChanged": "Đã đổi mật khẩu và đăng xuất các phiên khác. Phiên hiện tại vẫn hoạt động.",
  "edit": "Sửa {{name}}",
  "event_created": "Tạo tài khoản",
  "event_profile_updated": "Đổi tên",
  "event_role_changed": "Đổi vai trò",
  "event_disabled": "Khóa tài khoản",
  "event_enabled": "Mở khóa tài khoản",
  "event_password_reset": "Đặt lại mật khẩu tạm",
  "event_password_changed": "Người dùng đổi mật khẩu"
};
export const userWorkspaceZh = {
  "search": "搜索姓名或邮箱",
  "allRoles": "所有角色",
  "allStatuses": "所有状态",
  "sort": "账户排序",
  "newest": "最新创建",
  "name": "姓名 A–Z",
  "email": "邮箱 A–Z",
  "lastLogin": "最近登录",
  "reset": "重置筛选",
  "passwordState": "密码",
  "temporary": "需要更改",
  "personal": "无需更改",
  "never": "尚未登录",
  "updated": "更新 / 操作者",
  "created": "创建 / 操作者",
  "system": "系统 / 旧数据",
  "profile": "账户信息",
  "profileHint": "更改角色或状态会撤销现有会话。停用账户无法登录。",
  "resetTitle": "设置临时密码",
  "resetHint": "重置 {{email}} 的密码会注销所有现有会话。用户必须更改密码才能使用系统。",
  "acknowledge": "我了解此操作会使该用户退出登录并要求更改密码。",
  "resetDone": "临时密码已保存，旧会话已撤销。下次登录必须更改密码。",
  "createHint": "初始密码为临时密码。用户必须更改密码才能使用系统。",
  "history": "安全记录",
  "historyHint": "自此版本起记录最近100个事件，不记录密码值。",
  "noHistory": "尚无安全事件。",
  "historyError": "无法加载安全记录。",
  "actor": "操作者",
  "requiredPassword": "{{name}}，请先更改临时密码。完成前无法使用其他页面。",
  "requiredGeneric": "请先更改临时密码。",
  "signOut": "退出登录",
  "currentIncorrect": "当前密码不正确。",
  "passwordUnchanged": "请选择与当前密码不同的新密码。",
  "accountChanged": "保存时账户已变更，请重新登录再试。",
  "passwordChanged": "密码已更改，其他会话已退出登录。当前会话仍有效。",
  "edit": "编辑 {{name}}",
  "event_created": "创建账户",
  "event_profile_updated": "更改姓名",
  "event_role_changed": "更改角色",
  "event_disabled": "停用账户",
  "event_enabled": "启用账户",
  "event_password_reset": "重置临时密码",
  "event_password_changed": "用户更改密码"
};